<template>
    <div class="grid grid--container">
        <slot></slot>
    </div>
</template>
<style lang="scss"></style>
